import { Button, ButtonVariant } from '@clover/web-lib-consumer-ui';
import { useNavigate, useLocation } from '@reach/router';
import CtaItem from 'components/ModalKit/Cta/CtaItem';
import { StackedCtaLayout } from 'components/ModalKit/Cta/StackedCtaLayout';
import Typography from 'components/Typography/Typography';
import { useWindowSize } from 'hooks/breakpoints';
import { useCustomer } from 'hooks/context/customer/customer';
import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { DELIVERY_ADDRESS_MODAL } from 'routes/DeliveryAddressModal/DeliveryAddressModal.const';
import { useDeliveryAddressForm } from 'routes/DeliveryAddressModal/hooks/useDeliveryAddressForm';
import { DeliveryAddressModalSaveCheckbox } from '../Checkbox/DeliveryAddressModalSaveCheckbox';
import styles from './DeliveryAddressModalFooter.module.scss';

export const DeliveryAddressModalFooter: FC = () => {
  const { t } = useTranslation();
  const { isDesktop } = useWindowSize();
  const { isReviewing } = useDeliveryAddressForm();
  const { isLoggedIn } = useCustomer();

  const navigate = useNavigate();
  const { pathname } = useLocation();
  const isCheckoutPage = pathname && pathname.includes('checkout');

  const state = {
    redirectPath: isCheckoutPage ? '~checkout/address' : '~address',
    basePath: isCheckoutPage ? '~checkout' : '~menu',
    isDeliveryFlow: true,
  };
  const login = () => navigate('login/info', { state });

  return (
    <div className={styles.footer}>
      {!isReviewing && !isLoggedIn && (
        <CtaItem.Custom>
          <div className={styles.loginTextContainer}>
            <Typography.Body>{t('deliveryAddressModal.returningDeliveryText')}</Typography.Body>
            <Button data-testid={DELIVERY_ADDRESS_MODAL.loginButtonTestId} variant={ButtonVariant.TEXT} onClick={login}>
              <Typography.Body>{t('login')}</Typography.Body>
            </Button>
          </div>
        </CtaItem.Custom>
      )}
      {isDesktop && isLoggedIn && (
        <CtaItem.Custom>
          <DeliveryAddressModalSaveCheckbox />
        </CtaItem.Custom>
      )}
      <StackedCtaLayout>
        <CtaItem.Primary
          data-testid={DELIVERY_ADDRESS_MODAL.continueButtonTestId}
          className={styles.primaryButton}
          type="submit"
        >
          {t('deliveryAddressModal.continue')}
        </CtaItem.Primary>
      </StackedCtaLayout>
    </div>
  );
};
